import { useLocation } from "react-router-dom";

/**
 * Returns true if the current URL starts with /fr/
 */
export const isFrenchPath = (pathname: string): boolean => {
  return pathname === "/fr" || pathname.startsWith("/fr/");
};

/**
 * Strips the /fr prefix from a pathname, returning the base path.
 * e.g. "/fr/brand/nike" → "/brand/nike", "/brand/nike" → "/brand/nike"
 */
export const stripLocalePrefix = (pathname: string): string => {
  if (pathname === "/fr") return "/";
  if (pathname.startsWith("/fr/")) return pathname.slice(3);
  return pathname;
};

/**
 * Adds the /fr prefix to a path for French locale.
 * e.g. "/" → "/fr", "/brand/nike" → "/fr/brand/nike"
 */
export const addFrPrefix = (path: string): string => {
  if (path === "/") return "/fr";
  return `/fr${path}`;
};

/**
 * Returns locale-aware path based on language.
 */
export const localePath = (path: string, language: "fr" | "en"): string => {
  if (language === "fr") return addFrPrefix(path);
  return path;
};

/**
 * Hook that returns a function to generate locale-aware paths.
 */
export const useLocalePath = () => {
  const { pathname } = useLocation();
  const isFr = isFrenchPath(pathname);

  const getPath = (basePath: string): string => {
    return isFr ? addFrPrefix(basePath) : basePath;
  };

  return { getPath, isFr, basePath: stripLocalePrefix(pathname) };
};
